import { createFileRoute, Outlet, redirect, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import { auth, useAuth } from '@weebee/api';
import { CompanyProvider } from '@/lib/company-context';
import { Nav } from '@/components/layout/nav';

export const Route = createFileRoute('/app')({
  beforeLoad: async () => {
    await auth.authStateReady();
    if (!auth.currentUser) {
      throw redirect({ to: '/login' });
    }
  },
  component: AppLayout,
});

function AppLayout() {
  const authState = useAuth();
  const navigate = useNavigate();

  const handleNoCompany = useCallback(() => {
    void navigate({ to: '/no-company' });
  }, [navigate]);

  const handleError = useCallback((message: string) => {
    console.error('[CompanyProvider] API error:', message);
  }, []);

  if (authState.status !== 'authenticated') {
    return null;
  }

  return (
    <CompanyProvider onNoCompany={handleNoCompany} onError={handleError}>
      <div className="min-h-screen bg-background">
        <Nav />
        <main className="max-w-5xl mx-auto px-4 sm:px-6 py-6 sm:py-8 animate-fade-in-up">
          <Outlet />
        </main>
      </div>
    </CompanyProvider>
  );
}
